<template>
  <div>
    <a-drawer
      title=""
      placement="right"
      :maskClosable="false"
      :visible="visible"
      :destroyOnClose="true"
      :mask="false"
      width="400"
      :closable="false"
      class="ai-draw-box"
      :afterVisibleChange="afterVisibleChange"
      @close="onClose"
    >
      <div class="header-box">
        <div class="title-box">
          <!-- <span class="icon-ai-blue"></span> -->
          <div class="ai-icon"></div>
          <span class="name">{{ content[type].title }}</span>
          <a-icon
            type="close"
            class="icon-close"
            @click="onClose"
            :style="{
              fontSize: '20px',
              color: '#fff',
            }"
          />
        </div>
      </div>
      <div class="sub-box">
        <div class="header-tips">
          {{ content[type].tips }}
        </div>
        <div class="box-pading">
          <div class="style-box" v-if="type > 0">
            <p class="title">模板风格选择</p>
            <div class="type-box">
              <span
                :class="{ item: true, 'status-select': v.value === typeId }"
                v-for="v in typeList"
                @click="handleStyle(v.value)"
                :key="v.value"
              >{{ v.label }}</span
              >
            </div>
          </div>
          <div class="generate-section">
            <a-button
              type="primary"
              :disabled="
                loading || ((!sources || sources.length === 0) && type === 0)
              "
              :loading="loading"
              block
              class="start-btn"
              @click="getResult(type)"
            >
              <span class="icon-star" v-show="!loading"></span>
              <span class="icon-loading" v-show="loading"></span>
              <span class="btn-text"> {{ btnText }}</span>
            </a-button>
          </div>
          <span
            v-if="type === 0"
            :class="{ tips: true, blue: sources && sources.length > 0 }"
          >{{
            sources && sources.length > 0
              ? '已选中' + sources.length + '条日志'
              : '请勾选左侧日志进行生成'
          }}，日报生成剩余次数：{{ remainingCounts.daily }}</span
          >
          <div class="count-tips">
            <!-- <span v-if="type === 0" class="count-item">
              日报生成剩余次数：<span class="count-num">{{ remainingCounts.daily }}</span>
            </span> -->
            <span v-if="type === 1" class="count-item">
              周报生成剩余次数：<span class="count-num">{{
                remainingCounts.weekly
              }}</span>
            </span>
            <span v-if="type === 2" class="count-item">
              月报生成剩余次数：<span class="count-num">{{
                remainingCounts.monthly
              }}</span>
            </span>
          </div>
        </div>
        <div class="content" v-if="aiResult">
          <div class="content-hg">
            <span class="lf">AI输出结果</span>
            <div class="rt-group">
              <span
                class="rt edit-btn"
                v-if="type === 0"
                :class="{ disabled: loading || type !== 0 }"
                @click="openEditModal"
              ><span>✏️</span>编辑</span
              >
              <span
                class="rt"
                :class="{ disabled: loading }"
                @click="copyResult"
              ><span>📋</span>复制</span
              >
            </div>
          </div>
          <div v-html="renderHtml" class="md-content"></div>
        </div>
        <div class="action-box" v-if="aiResult">
          <div
            class="save-btn"
            :class="{ disabled: loading }"
            @click="saveResult"
          >
            <span class="icon-save"></span>
            {{
              type === 0
                ? '保存结果'
                : type === 1
                  ? '应用到周报总结'
                  : '应用到月报总结'
            }}
          </div>
          <!-- <a-button
        type="primary"
        block
        class="btn-blue"
        @click="saveResult">
        {{ type === 0 ?'保存结果' :type === 1?'应用到周报总结':'应用到月报总结' }}
      </a-button> -->
          <!-- <div class="btn btn-green" @click="saveResult">保存结果</div> -->
        </div>
      </div>
      <a-modal
        title="编辑AI结果"
        :visible="editModalVisible"
        :footer="null"
        :destroyOnClose="true"
        v-if="type === 0"
        width="1000px"
        @cancel="closeEditModal"
      >
        <div class="editor-modal-content" v-if="MyTinymceShow">
          <MyTinymce
            :placeholder="'请输入工作计划内容'"
            v-model="editContent"
            v-if="MyTinymceShow"
            type="AIPlan"
            ref="AIPlan"
          />
        </div>
        <div class="editor-modal-footer">
          <a-button @click="closeEditModal">取消</a-button>
          <a-button type="primary" @click="saveEditContent">保存修改</a-button>
        </div>
      </a-modal>
    </a-drawer>
  </div>
</template>

<script>
import { fetchEventSource } from '@microsoft/fetch-event-source'
import { convertHtmlToText, convertHtmlToMarkdown } from '@/utils'
import { userPlanList, getAiQuota } from '@/api/report'
import { getToken } from '@/utils/auth'
import moment from 'moment'
import DOMPurify from 'dompurify'
import { marked } from 'marked'
import AiEditor from '@/components/AiEditor/index.vue'
import MyTinymce from '@/components/Editor/indexAi.vue'
marked.setOptions({
  gfm: true, // 开启github标准md（有序/无序列表、标题）
  breaks: true, // 单行换行自动转<br>
  smartLists: true, // 智能识别列表，禁止自动嵌套子列表
  headerIds: false, // 关闭自动生成id，减少多余属性
  mangle: false,
})
export default {
  components: {
    MyTinymce,
  },
  props: {
    formDataYear: {
      type: Object,
      default: () => {
        return {}
      },
    },
    show: { type: Boolean, default: false },
    sources: {
      type: Array,
      default: () => [],
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    show(value) {
      this.visible = this.show
    },
    sources() {
      // console.log(this.sources)
    },
  },
  computed: {
    IsEnterprise() {
     return this.$store.state.user.userInfo.userType === 0
    },
  },
  data() {
    return {
      editModalVisible: false,
      convertHtmlToMarkdown: convertHtmlToMarkdown,
      MyTinymceShow: false,
      visible: false,
      content: [
        {
          title: 'AI智能助手',
          tips: '自动提取日志中的核心信息（完成情况、风险、资源），生成结构化摘要。',
        },
        {
          title: 'AI周报生成',
          tips: '将本周范围内的日志聚合成一份完整的周报。',
        },
        {
          title: 'AI月报生成',
          tips: '将本月范围内的日志聚合成一份完整的月报。',
        },
      ],
      typeList: [
        {
          value: 'formal',
          label: '正式',
        },
        {
          value: 'relaxed',
          label: '轻松',
        },
        {
          value: 'minimalist',
          label: '简约',
        },
      ],
      typeId: 'formal',
      aiResult: '',
      loading: false,
      btnText: '开始生成',
      rawFullText: '', // 存放所有分片拼接后的完整原始文本（不转markdown）
      renderHtml: '',
      copyHtml: '', //复制的html文本
      controller: null,
      scrollTimer: null,
      renderTimer: null,
      remainingCounts: {
        daily: 0,
        weekly: 0,
        monthly: 10,
      },
    }
  },
  methods: {
    reset() {
      this.MyTinymceShow = false
      this.visible = false
      this.aiResult = ''
      this.loading = false
      this.btnText = '开始生成'
      this.rawFullText = '' // 存放所有分片拼接后的完整原始文本（不转markdown）
      this.renderHtml = ''
      this.copyHtml = '' //复制的html文本
      this.controller = null
      this.scrollTimer = null
      this.renderTimer = null
      this.editModalVisible = false
      this.editContent = ''
    },
    async getRemainingCounts() {
      try {
        const [err, response] = await getAiQuota()
        // console.log(err)
        // console.log(response)
        const data = response || {}
        const quotas = response.quotas || []
        const counts = {
          daily: 0,
          weekly: 0,
          monthly: 0,
        }
        quotas.forEach((q) => {
          switch (q.planType) {
            case 4:
              counts.daily = q.remaining
              break
            case 3:
              counts.weekly = q.remaining
              break
            case 2:
              counts.monthly = q.remaining
              break
          }
        })
        this.remainingCounts = counts
      } catch (error) {
        console.error('获取剩余次数失败:', error)
      }
    },
    handleStyle(val) {
      this.typeId = val
    },
    async userPlanListFun() {
      const style = this.typeList.find((v) => v.value === this.typeId).value
      const params =
        this.type == 1
          ? {
              style,
            }
          : {
              planYear: this.formDataYear.planYear,
              planMonth: this.formDataYear.planMonth,
              style,
            }
      this.createSseConnect({
        ...params,
      })
    },
    async createSseConnect(params) {
      // const baseURL = process.env.SERVER_DOMAIN
      // if(process.env.VUE_APP_MODE === 'testcce') {
      //   baseURL = 'https://' + window.location.host
      // } else {
      //   baseURL = process.env.VUE_APP_API_BASE_URL
      // }
      // 创建中断控制器
      this.controller = new AbortController()
      const urlList = [
        '/front/dailylog/v1/ai/dailyPlan/summarize',
        '/front/dailylog/v1/ai/weekPlan/summarize',
        '/front/dailylog/v1/ai/monthPlan/summarize',
      ]
      try {
        this.loading = true
        this.btnText = '生成中'
        await fetchEventSource(
          // 'http://192.168.95.53:7001' + urlList[this.type],
          process.env.VUE_APP_API_BASE_URL + urlList[this.type],
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              authorization: getToken(),
              // 'Accept': 'text/event-stream',
            },
            body: JSON.stringify(params),
            signal: this.controller.signal,
            openWhenHidden: true, // 页面退至后台时保持连接
            onopen: (response) => {
              // console.log('SSE 连接已建立', response)
              if (response.status !== 200) {
                this.btnText = '重新生成'
                this.closeSSE()
                return
              }
              this.aiResult = ''
              this.rawFullText = ''
              this.renderHtml = ''
              this.loading = true
              this.btnText = '生成中'
            },
            onmessage: (event) => {
              // console.log('收到消息:', event)
              if (event.event === 'error') {
                this.$message.error(
                  JSON.parse(event.data).message || '生成失败：无有效数据',
                )
                this.aiResult = ''
                this.rawFullText = ''
                this.renderHtml = ''
                this.btnText = '重新生成'
                // this.controller.closeSSE()
                this.closeSSE()
                return
              }
              if (event.event === 'done') {
                this.btnText = '重新生成'
                this.closeSSE()
                const mdText = convertHtmlToMarkdown(this.rawFullText)
                this.fullRender() // 全部接收完成，完整渲染一次
                this.getRemainingCounts() // 生成完成后重新获取剩余次数
                return
              }
              const chunk = event.data.replace(/\\n/g, '\n')
              //  chunk = chunk.replace(/\\n/g, '\n')
              // const chunk = event.data
              //   .replaceAll('\\\\n', '\n')
              //   .replaceAll('\\n', '\n')
              this.aiResult += event.data
              this.rawFullText += chunk
              // const rawHtml = marked.parse(this.rawFullText)
              // this.renderHtml = DOMPurify.sanitize(rawHtml)

              this.debounceRender()
            },
            onerror: (error) => {
              console.error('SSE 错误:', error)
              this.$message.error('生成失败！' + error.message)
              this.aiResult = ''
              this.rawFullText = ''
              this.renderHtml = ''
              this.btnText = '重新生成'
              // this.controller.closeSSE()
              this.closeSSE()
              throw error // 抛出让库自动重连
            },
          },
        )
      } catch (error) {
        console.error('SSE 请求失败:', error)
        this.aiResult = ''
        this.rawFullText = ''
        this.renderHtml = ''
        this.closeSSE()
      }
    },
    /**
     * 标准化清洗markdown，解决标题混乱、换行缺失、列表缩进嵌套
     * @param {string} rawMd 原始拼接流式文本
     * @returns {string} 格式化标准md
     */
    formatStandardMarkdown(rawMd) {
      let md = rawMd || ''
      md = md.replaceAll('\\\\n', '\n').replaceAll('\\n', '\n')
      md = md.replace(/-[ \t\u00A0]+(\*\*)/g, '-  $1')
      md = md.replace(/^\s+|\s+$/g, '')
      return md
    },

    // 1. 清除首尾包裹的p标签
    fullRender() {
      clearTimeout(this.renderTimer)
      const cleanMd = this.formatStandardMarkdown(this.rawFullText)
      this.renderHtml = ''
      // console.log(this.rawFullText, '最终')
      this.$nextTick(() => {
        const html = marked.parse(cleanMd, {
          gfm: true, // 开启github标准md（有序/无序列表、标题）
          breaks: true, // 单行换行自动转<br>
          smartLists: true, // 智能识别列表，禁止自动嵌套子列表
          headerIds: false, // 关闭自动生成id，减少多余属性
          mangle: false,
        })
        this.renderHtml = DOMPurify.sanitize(html)
        this.copyHtml = this.renderHtml
      })
    },

    debounceRender() {
      clearTimeout(this.renderTimer)
      this.renderTimer = setTimeout(() => {
        const tempMd = this.formatStandardMarkdown(this.rawFullText)
        const html = marked.parse(tempMd, { gfm: true, breaks: true })
        this.renderHtml = DOMPurify.sanitize(html)
        this.debouncedScroll()
      }, 40) // 40ms延迟，打字流畅不卡顿
    },
    closeSSE() {
      this.loading = false
      this.btnText = '重新生成'
      if (this.controller) {
        this.controller.abort()
        // console.log('SSE 连接已关闭')
      }
    },
    getResult(type) {
      let detailText = ''
      if (type === 0) {
        this.sources.forEach((v) => {
          // console.log(v.workPlan)
          detailText += v.workPlan + '/n'
          // console.log(convertHtmlToText(v.workPlan))
        })
        const params = {
          // text: detailText,
          dailyPlanIds: this.sources.map((v) => v.id),
        }
        this.createSseConnect(params)
      } else {
        this.userPlanListFun()
      }
    },
    saveResult() {
      if (this.loading) {
        return
      }
      this.$emit('onResult', this.renderHtml)
    },
    openEditModal() {
      if (this.loading) {
        return
      }
      this.editModalVisible = true
      this.editContent = this.copyHtml || this.renderHtml || ''
      setTimeout(() => {
        this.MyTinymceShow = true
      }, 500)
      // this.editContent = this.copyHtml || this.renderHtml || ''
    },
    closeEditModal() {
      this.editModalVisible = false
      this.editContent = ''
    },
    saveEditContent() {
      if (this.editContent) {
        this.renderHtml = this.editContent
        this.copyHtml = this.editContent
        this.$message.success('修改已保存')
      }
      this.closeEditModal()
    },
    async copyResult() {
      if (this.loading) {
        return
      }
      // console.log(this.copyHtml,'复制Html内容')
      // 环境兼容判断
      if (!navigator || !navigator.clipboard) {
        // 降级：简易文本复制（兼容所有浏览器）
        const textarea = document.createElement('textarea')
        textarea.value = this.rawFullText
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message.success('复制成功（纯文本，粘贴后重新调整格式）')
        return
      }

      try {
        // 支持clipboard的现代浏览器，复制带格式HTML
        const htmlBlob = new Blob([this.copyHtml], { type: 'text/html' })
        const textBlob = new Blob([this.rawFullText], { type: 'text/plain' })
        await navigator.clipboard.write([
          new ClipboardItem({
            'text/html': htmlBlob,
            'text/plain': textBlob,
          }),
        ])
        this.$message.success('复制成功，粘贴到富文本可保留标题/列表/加粗')
      } catch (err) {
        // 高级API失败时降级纯文本
        await navigator.clipboard.writeText(this.rawFullText)
        this.$message.error('格式复制失败，已复制纯文本')
      }
    },
    afterVisibleChange(visible) {
      if (!visible) {
        this.$emit('onClose', visible)
      }
    },
    onClose() {
      this.visible = false
    },
    debouncedScroll() {
      clearTimeout(this.scrollTimer)
      this.scrollTimer = setTimeout(() => {
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      }, 100)
    },
    scrollToBottom() {
      const container = this.$refs.resultRef
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    },
  },
  mounted() {
    if (this.IsEnterprise) {
      this.getRemainingCounts()
    }
   
  },
  destroyed() {
    this.closeSSE()
  },
}
</script>

<style lang="less" scoped>
.md-content {
  text-align: left !important;
  line-height: 1.8;
  word-break: break-word;
}
.md-content h2 {
  font-size: 20px;
  font-weight: bold;
  margin: 8px 0;
}
.md-content h3 {
  font-size: 17px;
  font-weight: bold;
  margin: 6px 0;
}
.md-content ul {
  padding-left: 20px;
}
/deep/.md-content img {
  max-width: 100% !important;
  height: auto !important;
}
/** */
.box-pading {
  padding: 30px;
  padding-top: 10px;
}

.ai-draw-box {
  font-size: 12px;
  /deep/.ant-drawer-content {
    background-image: linear-gradient(
      to bottom,
      #ffffff 0%,
      #ffffff 70%,
      #f0f7ff 85%,
      #e6f0fc 100%
    ) !important;
    box-shadow: -15px 0px 17px 3px rgba(181, 182, 183, 0.27) !important;
  }

  /deep/ .ant-drawer-body {
    padding: 0;
  }
  .header-box {
    // background: linear-gradient(135deg, #4a90e2 0%, #5da9f7 100%);
    padding: 18px 20px;
    // box-shadow: 0 2px 12px rgba(74, 144, 226, 0.25);
    background-image: linear-gradient(#0176f6, #0176f6),
      linear-gradient(#0176f6, #0176f6);
    background-blend-mode: normal, normal;
    .title-box {
      display: flex;
      align-items: center;

      gap: 10px;
      .name {
        font-size: 24px;
        font-weight: 600;
        flex: 1;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #fff;
      }
      .ai-icon {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        background: url('../../assets/images/AI/AI_white.svg') no-repeat center;
        background-size: 100%;
      }
      .icon-ai-blue {
        display: inline-block;
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        background: url('../../assets/images/icon_AI.png') no-repeat center;
        background-size: 100% 100%;
      }
      .icon-close {
        flex-shrink: 0;
        cursor: pointer;
      }
    }
  }
  .sub-box {
    // padding: 15px;
    text-align: center;
    .header-tips {
      padding: 20px 41px;
      text-align: left;
      background-color: #f2f3f3;
      margin-bottom: 10px;
      animation: fadeIn 0.4s ease-out;
      font-size: 12px;
      line-height: 22px;
      color: #666666;
    }
    .tips {
      color: #999;
      font-size: 12px;
      text-align: center;
      margin-top: 10px;
      margin-bottom: 0;
      &.blue {
        color: #1890ff;
        font-size: 13px;
        background: none;
        border: none;
        cursor: pointer;
        text-decoration: none;
        transition: all 0.2s ease;
        padding: 4px 8px;
        border-radius: 4px;
        &:hover {
          background: #e6f7ff;
          color: #096dd9;
        }
      }
    }
    .style-box {
      p {
        font-size: 14px;
        font-weight: 600;
        color: #262626;
        text-align: left;
      }
      .type-box {
        display: flex;
        font-size: 14px;
        margin-bottom: 15px;
        gap: 12px;
        .item {
          padding: 0 24px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          border: none;
          cursor: pointer;
          border-radius: 8px;
          background-color: #f5f5f5;
          color: #666666;
          transition: all 0.3s ease;
          &.status-select {
            background-color: #e6f7ff;
            color: #1890ff;
            font-weight: 500;
          }
          &:hover {
            background-color: #e8f4fd;
            color: #40a9ff;
          }
        }
      }
    }
    .generate-section {
      margin-bottom: 10px;
      .start-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        .btn-text {
          margin-left: 5px;
        }
      }
      .icon-star {
        display: inline-block;
        width: 14px;
        height: 14px;
        line-height: 14px;
        background: url('../../assets/images/AI/AI_white.svg') no-repeat center;
        background-size: 100% 100%;
      }
      .icon-loading {
        display: inline-block;
        width: 14px;
        height: 14px;
        line-height: 14px;
        background: url('../../assets/images/AI/loading.svg') no-repeat center;
        background-size: 100% 100%;
      }
      // .start-btn {
      //   padding: 14px;
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      //   gap: 6px;
      //   font-weight: 500;
      // }
      /deep/ .ant-btn-primary {
        transition: all 0.3s ease;
        box-shadow: 0 4px 12px rgba(24, 144, 255, 0.25);
        background: linear-gradient(135deg, #40a9ff 0%, #1890ff 100%);
      }
      /deep/ .ant-btn-primary[disabled] {
        background: #f5f5f5;
        box-shadow: 0 4px 12px rgba(225, 226, 227, 0.25);
        span {
          background: transparent;
        }
      }
      /deep/ .ant-btn {
        height: 42px;
        border-radius: 8px;
        font-size: 15px;
        font-weight: 500;
        border: none;
      }
      .count-tips {
        margin-top: 8px;
        text-align: center;
        .count-item {
          font-size: 12px;
          color: #666;
          .count-num {
            color: #1890ff;
            font-weight: 600;
          }
        }
      }
    }
  }
  .content {
    padding: 0 20px;
    .content-hg {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      font-size: 12px;
      color: #262626;
      border-bottom: 2px solid #e6f7ff;
      padding-bottom: 10px;
      .lf {
        font-size: 14px;
        font-weight: 600;
      }
      .rt-group {
        display: flex;
        gap: 8px;
      }
      .rt {
        cursor: pointer;
        color: #666;
        border: 1px solid #d9d9d9;
        padding: 6px 12px;
        font-size: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        border-radius: 6px;
        &.edit-btn {
          background: #e6f7ff;
          border-color: #91d5ff;
          color: #1890ff;
        }
        span {
          margin-right: 5px;
        }
        &.disabled {
          cursor: not-allowed;
          opacity: 0.5;
          background: #f5f5f5 !important;
          border-color: #d9d9d9 !important;
          color: #999 !important;
        }
      }
    }
    .content-result {
      width: 100%;
      height: 300px;
      resize: none;
      outline: none;
      background: white;
      border: 1px solid #d9d9d9;
      border-radius: 8px;
      padding: 16px;
      margin-bottom: 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
      font-size: 14px;
      line-height: 1.8;
      color: #333;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
        'Helvetica Neue', Arial, sans-serif;
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: rgba(24, 144, 255, 0.3);
        border-radius: 3px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: rgba(24, 144, 255, 0.5);
      }
      &:focus {
        border-color: #1890ff;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
      }
      &::placeholder {
        color: #bfbfbf;
      }
    }
  }
  .action-box {
    padding: 0 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    .save-btn {
      width: 100%;
      text-align: center;
      padding: 9px;
      background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
      color: white;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(82, 196, 26, 0.25);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      .icon-save {
        background: url('../../assets/images/AI/save.svg') no-repeat center;
        background-size: 100% 100%;
        width: 20px;
        height: 20px;
      }
      &.disabled {
        cursor: not-allowed;
        opacity: 0.6;
        background: #d9d9d9 !important;
        box-shadow: none !important;
      }
    }
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.editor-modal-content {
  margin-bottom: 16px;
}
.editor-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
</style>
